<template>

</template>

<script>
  export default {
    created: function () {
      window.location.href = '/home'
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/NotFound.vue